import { render, staticRenderFns } from "./DevisPage.vue?vue&type=template&id=148f73cc&scoped=true"
import script from "./DevisPage.vue?vue&type=script&lang=js"
export * from "./DevisPage.vue?vue&type=script&lang=js"
import style0 from "./DevisPage.vue?vue&type=style&index=0&id=148f73cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f73cc",
  null
  
)

export default component.exports